"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lockRequestRejectedFromUpdate = exports.lockRequestFromUpdate = exports.updateLockFromUpdate = exports.hideCompositionLockToast = exports.hideLockedModal = exports.showLockedModal = exports.rejectRequestLockFromUser = exports.requestLockFromUser = exports.passLock = exports.releaseLock = exports.requestLock = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var _sessionManagersHelpers = require("composer-lib/lib/helpers/sessionManagersHelpers");

var _RealtimeManager = _interopRequireDefault(require("composer-lib/data/RealtimeManager"));

var getLockManager = function getLockManager(session) {
  return (0, _sessionManagersHelpers.getManagerWithSession)('lock', session);
};

var acquireLock = (0, _utils.createAction)(_ActionTypes.default.ACQUIRE_LOCK);
var acquireLockSucceeded = (0, _utils.createAction)(_ActionTypes.default.ACQUIRE_LOCK_SUCCEEDED);
var acquireLockFailed = (0, _utils.createAction)(_ActionTypes.default.ACQUIRE_LOCK_FAILED);

var requestLock = function requestLock(id, session) {
  return function (dispatch) {
    dispatch(acquireLock);
    getLockManager(session).acquireLock(id).then(function (resp) {
      return dispatch(acquireLockSucceeded(resp));
    }, function (resp) {
      return dispatch(acquireLockFailed(resp));
    });
  };
};

exports.requestLock = requestLock;
var clearLock = (0, _utils.createAction)(_ActionTypes.default.CLEAR_LOCK);
var clearLockSucceeded = (0, _utils.createAction)(_ActionTypes.default.CLEAR_LOCK_SUCCEEDED);
var clearLockFailed = (0, _utils.createAction)(_ActionTypes.default.CLEAR_LOCK_FAILED);

var releaseLock = function releaseLock(id, session) {
  return function (dispatch) {
    dispatch(clearLock);
    getLockManager(session).clearLock(id).then(dispatch(clearLockSucceeded()), dispatch(clearLockFailed()));
  };
};

exports.releaseLock = releaseLock;
var passLockRequest = (0, _utils.createAction)(_ActionTypes.default.PASS_LOCK_REQUEST);

var passLock = function passLock(id, session, userId) {
  return function (dispatch) {
    dispatch(passLockRequest());
    getLockManager(session).passLock(id, userId);
  };
};

exports.passLock = passLock;
var requestLockSucceeded = (0, _utils.createAction)(_ActionTypes.default.REQUEST_LOCK_SUCCEEDED);

var requestLockFromUser = function requestLockFromUser(userId) {
  return function (dispatch) {
    _RealtimeManager.default.requestLock(userId).then(dispatch(requestLockSucceeded()));
  };
};

exports.requestLockFromUser = requestLockFromUser;

var rejectRequestLockFromUser = function rejectRequestLockFromUser(userId) {
  return function () {
    _RealtimeManager.default.rejectRequestLock(userId);
  };
};

exports.rejectRequestLockFromUser = rejectRequestLockFromUser;
var showLockedModal = (0, _utils.createAction)(_ActionTypes.default.LOCK_EDITING);
exports.showLockedModal = showLockedModal;
var hideLockedModal = (0, _utils.createAction)(_ActionTypes.default.LOCK_EDITING_DISMISSED);
exports.hideLockedModal = hideLockedModal;
var hideCompositionLockToast = (0, _utils.createAction)(_ActionTypes.default.LOCK_TOAST_DISMISSED);
exports.hideCompositionLockToast = hideCompositionLockToast;
var updateLockFromUpdate = (0, _utils.createAction)(_ActionTypes.default.REALTIME_UPDATE_LOCK);
exports.updateLockFromUpdate = updateLockFromUpdate;
var lockRequestFromUpdate = (0, _utils.createAction)(_ActionTypes.default.REALTIME_UPDATE_LOCK_REQUEST);
exports.lockRequestFromUpdate = lockRequestFromUpdate;
var lockRequestRejectedFromUpdate = (0, _utils.createAction)(_ActionTypes.default.REALTIME_UPDATE_LOCK_REQUEST_REJECTED);
exports.lockRequestRejectedFromUpdate = lockRequestRejectedFromUpdate;